import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {graphql} from 'react-apollo';
import {SaveMetaMutation, SaveMetaModalMutationConfig} from '../qql-shared/mutations';
class AddMetaModal extends Component {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
    metaTypeLabel: PropTypes.string.isRequired,
    metaType: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {metaType: props.metaType, value: ''};
  }
  _handleValueChange = (_, value) => {
    this.setState({value: value});
  };
  _save = () =>
    this.props.save({...this.state}).then(() => this.props.onCancel()).catch(error => {
      console.log('there was an error sending the query', error);
    });
  render() {
    const {metaTypeLabel} = this.props;
    const {value} = this.state;
    return (
      <Dialog
        title={`Neue(r) ${metaTypeLabel}  eintragen`}
        modal
        {...this.props}
        actions={[
          <FlatButton label="Abbrechen" onTouchTap={this.props.onCancel} />,
          <FlatButton label="Speichern" primary onTouchTap={this._save} />,
        ]}
      >
        <TextField
          type="text"
          fullWidth={true}
          floatingLabelText="Wert*"
          value={value}
          onChange={this._handleValueChange}
        />
      </Dialog>
    );
  }
}

export default graphql(SaveMetaMutation, SaveMetaModalMutationConfig)(AddMetaModal);



// WEBPACK FOOTER //
// ./src/components/AddMetaModal.js